import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { EventViewModel } from '../../../../model/events.model';
import { extractErrorMessage } from '../../../../common/common';
import { ApiService, CustomHttpParams } from 'src/app/services/api.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: "app-view-event",
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: "./view-event.component.html",
  styleUrl: "./view-event.component.scss",
})
export class ViewEventComponent implements OnInit {
  public params = new HttpParams();
  public eventId: any;
  public error: string | null = null;
  public eventViewModel: EventViewModel | null = null;
  public isLoading: boolean = false;
  public router: Router;

  constructor(private injector: Injector, private eventService: ApiService) {
    this.router = injector.get(Router);
    this.router.events.subscribe((event: any) => {
      if (event?.snapshot?.params.id) {
        this.eventId = event.snapshot.params.id;
      }
    });
  }

  ngOnInit(): void {
    if (this.eventId) {
      this.loadEvent();
    }
  }

  loadEvent() {
    this.isLoading = true;
    this.error = null;

    const params: CustomHttpParams = {
      'depth': 3,
      'id': this.eventId,
    };
    this.eventService
      .getEvents(params)
      .subscribe({
        next: (response: EventViewModel[]) => {
          if (response && response.length > 0) {
            this.eventViewModel = response[0];
            console.log('Event data:', this.eventViewModel); // Debug log
          } else {
            this.error = 'Event not found';
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error loading event:', err);
          this.error = extractErrorMessage(err);
          this.isLoading = false;
        }
      });
  }

  back() {
    this.router.navigate(['/events']);
  }

  // TrackBy functions for *ngFor optimization
  trackByMarketContextId(index: number, context: any): number {
    return context.id || index;
  }

  trackByGroupId(index: number, group: any): number {
    return group.id || index;
  }

  trackByResourceId(index: number, resource: any): number {
    return resource.id || index;
  }

  trackByPartyId(index: number, party: any): number {
    return party.party_id || index;
  }

  trackBySignalId(index: number, signal: any): number {
    return signal.signal_id || index;
  }

  trackByIntervalId(index: number, interval: any): number {
    return interval.uid || index;
  }
}
